export default __webpack_public_path__ + "static/media/academic.d4a6f28a.png";